import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export type CancellationRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED'

export interface RequisitionCancellationRequest {
  id: number
  requisitionId: string
  status: CancellationRequestStatus
  reason: string | null
  decidedAt: string | null
  createdAt: string
  decidedBy?: string | null
}

export interface CancellationDecisionPayload {
  reason?: string | null
}

const buildBody = (payload?: CancellationDecisionPayload) =>
  payload?.reason?.trim() ? { reason: payload.reason.trim() } : undefined

export function getRequisitionCancellationsAction(
  id: string
): Promise<ApiResponse<{ cancellationRequests?: RequisitionCancellationRequest[] }>> {
  return api.get<ApiResponse<{ cancellationRequests?: RequisitionCancellationRequest[] }>>(`/requisitions/${id}`)
}

export function approveRequisitionCancellationAction(
  id: string,
  payload?: CancellationDecisionPayload
): Promise<ApiResponse<RequisitionCancellationRequest>> {
  return api.v2.post<ApiResponse<RequisitionCancellationRequest>>(
    `/requisitions/${id}/cancellation/approve`,
    buildBody(payload)
  )
}

export function rejectRequisitionCancellationAction(
  id: string,
  payload?: CancellationDecisionPayload
): Promise<ApiResponse<RequisitionCancellationRequest>> {
  return api.v2.post<ApiResponse<RequisitionCancellationRequest>>(
    `/requisitions/${id}/cancellation/reject`,
    buildBody(payload)
  )
}
